import { useRouter } from 'next/router';

export enum Tabs {
  HOME = '',
  ANALYSIS = 'analysis',
  STATEMENTS = 'statements',
  DECISION = 'decision',
  DOCUMENTS = 'documents',
  FINANCIALDATA = 'financial-data',
  IDENTITY = 'identity',
  HISTORY = 'history',
  SETTINGS = 'settings',
}

export const defaultDashboardTab = Tabs.ANALYSIS;

export const dashboardTabUrl = '/organization/[organizationId]/project/[projectId]/dashboard/[customerId]/[tab]';

interface UrlObject {
  pathname: string;
  query: { [key: string]: string };
}

export const getDashboardTabRoute = (
  organizationId: string,
  projectId: string,
  customerId: string,
  tab: Tabs = defaultDashboardTab,
): UrlObject => ({
  pathname: dashboardTabUrl,
  query: { organizationId, projectId, customerId, tab },
});

interface DashboardParams {
  organizationId: string;
  projectId: string;
  customerId: string;
  currentTab: string;
}

export const useDashboardParams = (): DashboardParams => {
  const router = useRouter();

  const params = router.query as { organizationId: string; projectId: string; customerId: string; tab: string };

  return {
    organizationId: params.organizationId,
    projectId: params.projectId,
    customerId: params.customerId,
    currentTab: params.tab,
  };
};
